<template>
  <tr>
    <td class="sticky-action-cell border-b border-gray-200/75 py-2 pl-3 pr-1">
      <div v-if="!isSum" class="flex items-center justify-center gap-2">
        <FontAwesomeIcon
          v-if="!item.paid"
          :icon="isSelected ? ['fas', 'square-check'] : ['fal', 'square']"
          class="text-primary cursor-pointer"
          size="lg"
          @click.stop="$emit('select', item)"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'file-invoice']"
          class="text-primary cursor-pointer"
          size="lg"
          @click.stop="$emit('print', item)"
        />
      </div>
    </td>
    <td
      v-for="(column, index) in columns"
      :key="`td-${item.id}-${column.id}`"
      :class="{ 'sum-cell': isSum }"
      :style="`width: ${cellWidth[index]}`"
    >
      <div
        class="relative min-w-[50px] overflow-x-visible"
        :style="`width: ${cellWidth[index]}`"
      >
        <button
          v-if="column.type === 'title'"
          type="button"
          class="flex flex-1 flex-row items-start gap-1.5 px-3 py-3 text-left"
          :class="forceBold ? '!font-bold' : ''"
          @click.stop="$emit('edit', item)"
        >
          <span
            class="mt-1 h-3 w-3 shrink-0 rounded-full"
            :class="item.paid ? 'bg-green-400' : 'bg-orange-400'"
          />
          <span class="line-clamp-2 font-semibold">{{ item[column.field] }}</span>
        </button>
        <InvoiceRowElement
          v-else
          :column="column"
          :invoice="item"
          :index-invoice="indexItem"
          :indexcolumn="index"
          :class="forceBold ? '!font-bold' : ''"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import InvoiceRowElement from '@c/Dashboard/Content/Invoicing/components/Body/InvoiceRowElement.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'ThirdPartyCostRowComponent',
  components: { InvoiceRowElement, FontAwesomeIcon },
  props: {
    item: {
      type: Object,
      required: true
    },
    indexItem: {
      type: Number,
      required: false,
      default: 0
    },
    columns: {
      type: Array,
      required: true
    },
    cellWidth: {
      type: Array,
      required: false,
      default: () => []
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    isSum: {
      type: Boolean,
      required: false,
      default: false
    },
    forceBold: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select', 'print', 'edit']
}
</script>
